var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 246 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_397_3255)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_397_3255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 115C0 51.4872 51.4873 0 115 0H127C192.722 0 246 53.2781 246 119V127C246 192.722 192.722 246 127 246H123C55.069 246 0 190.931 0 123V115Z",
    fill: "url(#paint0_radial_397_3255)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_397_3255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.54 106C105.66 106 109.081 109.378 108.197 113.402C106.794 119.789 103.591 125.699 98.8952 130.395C92.4252 136.865 83.65 140.5 74.5 140.5C65.35 140.5 56.5748 136.865 50.1048 130.395C45.6509 125.941 42.5406 120.395 41.0346 114.386C39.8974 109.848 43.7924 106 48.4706 106C52.8564 106 56.2631 109.719 58.1273 113.689C59.0089 115.566 60.215 117.296 61.7097 118.79C65.1019 122.182 69.7027 124.088 74.5 124.088C79.2973 124.088 83.8981 122.182 87.2903 118.79C88.5423 117.538 89.5918 116.122 90.4178 114.591C92.7658 110.24 96.5961 106 101.54 106Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.54 106C105.66 106 109.081 109.378 108.197 113.402C106.794 119.789 103.591 125.699 98.8952 130.395C92.4252 136.865 83.65 140.5 74.5 140.5C65.35 140.5 56.5748 136.865 50.1048 130.395C45.6509 125.941 42.5406 120.395 41.0346 114.386C39.8974 109.848 43.7924 106 48.4706 106C52.8564 106 56.2631 109.719 58.1273 113.689C59.0089 115.566 60.215 117.296 61.7097 118.79C65.1019 122.182 69.7027 124.088 74.5 124.088C79.2973 124.088 83.8981 122.182 87.2903 118.79C88.5423 117.538 89.5918 116.122 90.4178 114.591C92.7658 110.24 96.5961 106 101.54 106Z",
    fill: "#221725"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_397_3255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.54 106C202.66 106 206.081 109.378 205.197 113.402C203.794 119.789 200.591 125.699 195.895 130.395C189.425 136.865 180.65 140.5 171.5 140.5C162.35 140.5 153.575 136.865 147.105 130.395C142.651 125.941 139.541 120.395 138.035 114.386C136.897 109.848 140.792 106 145.471 106C149.856 106 153.263 109.719 155.127 113.689C156.009 115.566 157.215 117.296 158.71 118.79C162.102 122.182 166.703 124.088 171.5 124.088C176.297 124.088 180.898 122.182 184.29 118.79C185.542 117.538 186.592 116.122 187.418 114.591C189.766 110.24 193.596 106 198.54 106Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.54 106C202.66 106 206.081 109.378 205.197 113.402C203.794 119.789 200.591 125.699 195.895 130.395C189.425 136.865 180.65 140.5 171.5 140.5C162.35 140.5 153.575 136.865 147.105 130.395C142.651 125.941 139.541 120.395 138.035 114.386C136.897 109.848 140.792 106 145.471 106C149.856 106 153.263 109.719 155.127 113.689C156.009 115.566 157.215 117.296 158.71 118.79C162.102 122.182 166.703 124.088 171.5 124.088C176.297 124.088 180.898 122.182 184.29 118.79C185.542 117.538 186.592 116.122 187.418 114.591C189.766 110.24 193.596 106 198.54 106Z",
    fill: "#221725"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_diiii_397_3255)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_397_3255",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.5352 189.398C72.4691 186.824 71.3807 181.312 74.7263 177.852C79.5896 172.823 85.336 168.583 91.7368 165.325C100.849 160.687 111.018 158.177 121.384 158.009C131.749 157.841 142.005 160.019 151.283 164.358C157.808 167.41 163.714 171.468 168.763 176.343C172.222 179.683 171.326 185.224 167.353 187.931C163.708 190.415 158.806 189.564 155.545 186.593C152.054 183.412 148.049 180.743 143.663 178.691C136.842 175.501 129.301 173.899 121.679 174.023C114.058 174.147 106.581 175.992 99.8809 179.402C95.5877 181.587 91.6949 184.374 88.3301 187.653C85.1612 190.742 80.2739 191.765 76.5352 189.398Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.5352 189.398C72.4691 186.824 71.3807 181.312 74.7263 177.852C79.5896 172.823 85.336 168.583 91.7368 165.325C100.849 160.687 111.018 158.177 121.384 158.009C131.749 157.841 142.005 160.019 151.283 164.358C157.808 167.41 163.714 171.468 168.763 176.343C172.222 179.683 171.326 185.224 167.353 187.931C163.708 190.415 158.806 189.564 155.545 186.593C152.054 183.412 148.049 180.743 143.663 178.691C136.842 175.501 129.301 173.899 121.679 174.023C114.058 174.147 106.581 175.992 99.8809 179.402C95.5877 181.587 91.6949 184.374 88.3301 187.653C85.1612 190.742 80.2739 191.765 76.5352 189.398Z",
    stroke: "url(#paint1_linear_397_3255)",
    strokeWidth: 22,
    strokeLinejoin: "round",
    mask: "url(#path-4-inside-1_397_3255)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_397_3255",
    x: -11,
    y: -24,
    width: 278,
    height: 326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_397_3255"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 21,
    dy: 73
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.682806 0 0 0 0 0.0652778 0 0 0 0 0.783333 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_3255"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.943639 0 0 0 0 0.223611 0 0 0 0 0.958333 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_397_3255",
    result: "effect2_innerShadow_397_3255"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -11,
    dy: 30
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.766722 0 0 0 0 0.693056 0 0 0 0.68 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_397_3255",
    result: "effect3_innerShadow_397_3255"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_397_3255",
    x: 40.8352,
    y: 106,
    width: 67.5018,
    height: 34.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 26.45,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_397_3255"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.2,
    dy: -7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_3255"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_397_3255",
    x: 137.835,
    y: 106,
    width: 67.5018,
    height: 34.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 26.45,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_397_3255"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.2,
    dy: -9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_3255"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_diiii_397_3255",
    x: 39.4131,
    y: 141.333,
    width: 164.832,
    height: 99.3673,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16.6667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.6667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0298758 0 0 0 0 0.0216858 0 0 0 0 0.0308333 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_397_3255"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_397_3255",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.18518
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.59259
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.17328 0 0 0 0 0.125777 0 0 0 0 0.178833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_397_3255"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.59259
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2963
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.119503 0 0 0 0 0.086743 0 0 0 0 0.123333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_397_3255",
    result: "effect3_innerShadow_397_3255"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 26.45,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_innerShadow_397_3255"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.2,
    dy: -9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_397_3255",
    result: "effect4_innerShadow_397_3255"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 26.45,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect5_innerShadow_397_3255"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.2,
    dy: -9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_397_3255",
    result: "effect5_innerShadow_397_3255"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_397_3255",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109 16) rotate(86.5167) scale(230.426)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.576389,
    stopColor: "#FFBB0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC907"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_397_3255",
    x1: 122.5,
    y1: 279,
    x2: 122.5,
    y2: 158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#201721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B1F2C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_397_3255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 246,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default __webpack_public_path__ + "static/media/sad-face.3f877b69453567d2c055b07e607e5197.svg";
export { ForwardRef as ReactComponent };